var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 385,
    viewBox: "0 0 385 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1803_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.455 360.91H24.061V24.061H180.455C187.096 24.061 192.485 18.671 192.485 12.031C192.485 5.39098 187.095 0.000976562 180.455 0.000976562H12.03C5.39 0.000976562 0 5.38998 0 12.031V372.94C0 379.581 5.39 384.97 12.03 384.97H180.454C187.095 384.97 192.484 379.58 192.484 372.94C192.485 366.299 187.095 360.91 180.455 360.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.481 184.088L298.472 99.8879C293.768 95.1359 286.153 95.1479 281.461 99.8879C276.757 104.628 276.757 112.327 281.461 117.067L344.019 180.527H96.279C89.638 180.527 84.249 185.965 84.249 192.678C84.249 199.391 89.639 204.829 96.279 204.829H344.019L281.461 268.289C276.757 273.041 276.757 280.728 281.461 285.468C286.165 290.22 293.78 290.22 298.472 285.468L381.469 201.268C386.113 196.588 386.161 188.756 381.481 184.088Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1803_1131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384.971,
    height: 384.971,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1498828e655770e6aa45928cff04bf5b.svg";
export { ForwardRef as ReactComponent };